import { Box, Typography } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
/**
 * A circular progress visualization component that renders a stroked SVG arc
 * representing a portion of a circle based on a numeric value from 0.0 to 1.0.
 *
 * @param {CircleBarProps} props - Props for configuring the circle bar.
 * @param {number} props.size - Diameter of the circle in pixels.
 * @param {number} props.strokeWidth - Width of the progress stroke.
 * @param {number} props.value - Value between 0.0 and 1.0 representing the progress.
 * @param {number} [props.offset] - Optional offset in radians (from 0 to Math.PI) for where progress starts.
 * @param {boolean} [props.antiClockwise] - If true, the progress is drawn counter-clockwise.
 * @param {string} [props.color] - Deprecated. Use `themeColor` instead. A custom stroke color string.
 * @param {keyof typeof themeColors.accent} [props.themeColor] - Theme-based color name from accent palette.
 * @param {boolean} [props.showPercent] - Whether to display the percentage text in the center.
 * @param {string} [props.data-test] - Testing identifier.
 *
 * @returns {JSX.Element} A circular progress bar component.
 */
export const CircleBar = (props) => {
    var _a;
    const r = props.size / 2 - props.strokeWidth / 2;
    return (React.createElement(Box, { width: props.size, height: props.size, sx: { display: 'inline-block', position: 'relative' }, "data-test": props['data-test'], "data-value": props.value },
        props.showPercent && (React.createElement(Box, { sx: {
                alignItems: 'center',
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                left: 0,
                position: 'absolute',
                right: 0,
                top: 0,
            } },
            React.createElement(Typography, { variant: 'subtitle1' },
                Math.round(props.value * 100),
                "%"))),
        React.createElement("svg", { width: props.size, height: props.size, viewBox: `0 0 ${props.size} ${props.size}` },
            React.createElement("g", null,
                React.createElement("circle", { cx: props.size / 2, cy: props.size / 2, r: r, fill: 'none', strokeWidth: props.strokeWidth, stroke: props.themeColor
                        ? themeColors.accent[props.themeColor].subtlest
                        : props.color
                            ? themeColors.accent.grey.subtlest
                            : themeColors.accent.blue.subtlest }),
                React.createElement("circle", { cx: props.size / 2, cy: props.size / 2, r: r, fill: 'none', strokeWidth: props.strokeWidth, stroke: props.themeColor
                        ? themeColors.accent[props.themeColor].base
                        : props.color
                            ? props.color
                            : themeColors.accent.blue.base, strokeDashoffset: (props.antiClockwise ? r * 2 * Math.PI * props.value : 0) + r * 2 * ((_a = props.offset) !== null && _a !== void 0 ? _a : 0), strokeDasharray: [r * 2 * Math.PI * props.value, r * 2 * Math.PI * (1 - props.value)].join(',') })))));
};
